var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-subscribers-page omapi-subscribers-segments"},[(!_vm.hasTags)?_c('monsterleads-segments-no-segments'):_c('monsterleads-segments-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }